import React from "react";

const NotFoundComponent = ({
  message,
  title = "Not found",
}: {
  message?: string;
  title?: string;
}) => (
  <>
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-center py-16">
      <h1 className="text-4xl font-bold text-ink-faint mb-2">{title}</h1>
      <h2 className="text-lg font-semibold text-ink-muted mb-2">
        {message || "Sorry, the content you are looking for does not exist."}
      </h2>
    </div>
  </>
);

export default NotFoundComponent;
